import styled from 'styled-components/macro';
import { colorCoreBlack900Base } from '@yme/tokens/colors';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
import { getTextStyles } from '@yme/utils/styles';
export const ProductBenefitWrapperStyled = styled.div `
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 24px;

  margin: ${INDENT.xl} ${INDENT.xs} 0 ${INDENT.xs};

  ${ADAPTIVE.minWidth.tablet} {
    margin: ${INDENT.xxxl} 45.5px 0 45.5px;
  }
`;
export const ProductBenefitStyled = styled.div `
  display: flex;
  flex: 1 1;
  justify-content: center;
  flex-wrap: wrap;
`;
export const ProductBenefitTextStyled = styled.div `
  ${getTextStyles('Ubuntu', 400, 14, 20)}

  color: ${colorCoreBlack900Base};

  text-align: center;
  width: 100%;
  margin-top: 8px;
`;
